
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investor-relations/leadership-team",
      function () {
        return require("private-next-pages/investor-relations/leadership-team.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investor-relations/leadership-team"])
      });
    }
  